export default "__VITE_ASSET__BXTY5dYc__"